import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";
import { Box, Container, Typography, Button } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import AddIcon from "@material-ui/icons/Add";
import { connect } from "react-redux";
import ExperienceListResults from "src/components/experiences/ExperienceListResults";
import { fetchExperiences } from "src/actions/ExperienceActions";

const TOKENS = {
  bg: "#F5F6FA",
  textPrimary: "#0F172A",
  textSecondary: "#64748B",
  accent: "#222222",
  accentDark: "#000000",
};

const useStyles = makeStyles((theme) => ({
  page: {
    backgroundColor: TOKENS.bg,
    minHeight: "100%",
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(6),
  },
  header: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    flexWrap: "wrap",
    gap: theme.spacing(2),
    marginBottom: theme.spacing(3),
  },
  title: {
    fontSize: 26,
    fontWeight: 700,
    color: TOKENS.textPrimary,
    lineHeight: 1.2,
    marginBottom: 4,
  },
  subtitle: { fontSize: 14, color: TOKENS.textSecondary },
  createBtn: {
    backgroundColor: TOKENS.accent,
    color: "#FFFFFF",
    textTransform: "none",
    fontWeight: 600,
    borderRadius: 10,
    padding: "8px 20px",
    boxShadow: "none",
    "&:hover": { backgroundColor: TOKENS.accentDark, boxShadow: "none" },
  },
}));

const ExperienceList = ({ fetchExperiences, experiences = [] }) => {
  const classes = useStyles();
  const navigate = useNavigate();

  useEffect(() => {
    fetchExperiences();
  }, [fetchExperiences]);

  const approvedCount = experiences.filter((e) => e.approved).length;
  const pendingCount = experiences.length - approvedCount;

  return (
    <>
      <Helmet>
        <title>Tubayo Host | Experiences</title>
      </Helmet>
      <Box className={classes.page}>
        <Container maxWidth={false} style={{ maxWidth: 1280 }}>
          <Box className={classes.header}>
            <Box>
              <Typography className={classes.title}>Experiences</Typography>
              <Typography className={classes.subtitle}>
                {experiences.length} total · {approvedCount} approved ·{" "}
                {pendingCount} pending
              </Typography>
            </Box>
            <Button
              className={classes.createBtn}
              startIcon={<AddIcon />}
              onClick={() => navigate("/app/createExperience")}
            >
              Create experience
            </Button>
          </Box>

          <ExperienceListResults experiences={experiences} />
        </Container>
      </Box>
    </>
  );
};

const mapStateToProps = (state) => ({
  experiences: state.experiences.experience,
});

export default connect(mapStateToProps, { fetchExperiences })(ExperienceList);
